import React from 'react';
import { Box, Typography } from '@mui/material';

const AnnouncementSection: React.FC<{ title: string }> = ({
  title,
  children,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="h2">{title}</Typography>
      <Box>{children}</Box>
    </Box>
  );
};

export default AnnouncementSection;
